import { h } from 'preact';
import { createPortal } from 'preact/compat';
import { Transition } from '@headlessui/react';

const portalContainer = document.getElementById('modals-portal');
const HeaderNavOverlay = ({ isActive }) => (
  <div>
    {createPortal(
      <Transition
        show={isActive}
        enter="transition-opacity ease-linear duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black/20" aria-hidden="true" />
      </Transition>,
      portalContainer,
    )}
  </div>
);

export default HeaderNavOverlay;
